// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: w8Gkq37ZXmVbqHV15DJUBW
// Component: PW2DlnoqOU
import * as React from "react";
import {
  Stack as Stack__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import NavBar2 from "../../NavBar2"; // plasmic-import: lLCcoonTe6o/component
import RadialSummary from "../../RadialSummary"; // plasmic-import: oyxikxJz0w/component
import Footer from "../../Footer"; // plasmic-import: EvRh7yjThy6/component
import "@plasmicapp/react-web/lib/plasmic.css";
import projectcss from "./plasmic_basil_site_2_0.module.css"; // plasmic-import: w8Gkq37ZXmVbqHV15DJUBW/projectcss
import sty from "./PlasmicTerminal.module.css"; // plasmic-import: PW2DlnoqOU/css

createPlasmicElementProxy;

export const PlasmicTerminal__VariantProps = new Array();

export const PlasmicTerminal__ArgProps = new Array();

const $$ = {};

function PlasmicTerminal__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  return (
    <React.Fragment>
      <div className={projectcss.plasmic_page_wrapper}>
        <Stack__
          as={"div"}
          data-plasmic-name={"root"}
          data-plasmic-override={overrides.root}
          data-plasmic-root={true}
          data-plasmic-for-node={forNode}
          hasGap={true}
          className={classNames(
            projectcss.all,
            projectcss.root_reset,
            projectcss.plasmic_default_styles,
            projectcss.plasmic_mixins,
            projectcss.plasmic_tokens,
            sty.root
          )}
        >
          <NavBar2
            data-plasmic-name={"navBar2"}
            data-plasmic-override={overrides.navBar2}
            className={classNames("__wab_instance", sty.navBar2)}
          />

          <div className={classNames(projectcss.all, sty.freeBox___1IQct)}>
            <h1
              data-plasmic-name={"h1"}
              data-plasmic-override={overrides.h1}
              aria-describedby={""}
              className={classNames(
                projectcss.all,
                projectcss.h1,
                projectcss.__wab_text,
                sty.h1,
                ""
              )}
              role={""}
            >
              <React.Fragment>
                <span
                  className={"plasmic_default__all plasmic_default__span"}
                  style={{ color: "#FFFFFF" }}
                >
                  {"Global Consumer Experience Index"}
                </span>
              </React.Fragment>
            </h1>
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__nPoJu
              )}
            >
              <React.Fragment>
                <React.Fragment>
                  {
                    "Basil Labs leverages its AI to distill millions of data points in order to create the Global Consumer Experience Index, which benchmark consumer sentiment of some of the largest brands across the world.\n\n"
                  }
                </React.Fragment>
                <span
                  className={"plasmic_default__all plasmic_default__span"}
                  style={{ color: "#16E71F" }}
                >
                  {"Click on a city below "}
                </span>
                <React.Fragment>
                  {
                    "to view a sample of some of the most prominent brick-and-mortar retail, F&B, hospitality, and other sector chains in the area."
                  }
                </React.Fragment>
              </React.Fragment>
            </div>
          </div>
          <div className={classNames(projectcss.all, sty.freeBox__vnLb9)}>
            <Stack__
              as={"div"}
              data-plasmic-name={"citySummary"}
              data-plasmic-override={overrides.citySummary}
              hasGap={true}
              className={classNames(projectcss.all, sty.citySummary)}
            >
              <div className={classNames(projectcss.all, sty.column___7YXkv)}>
                <RadialSummary
                  cityH1={
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__jAbHp
                      )}
                    >
                      {"Boston"}
                    </div>
                  }
                  className={classNames(
                    "__wab_instance",
                    sty.radialSummary__znY0
                  )}
                  nobox={true}
                  numLocations={"2000+ locations"}
                />
              </div>
              <div className={classNames(projectcss.all, sty.column__kL6Gs)}>
                <RadialSummary
                  className={classNames(
                    "__wab_instance",
                    sty.radialSummary__zuq84
                  )}
                  nobox={true}
                />
              </div>
              <div className={classNames(projectcss.all, sty.column__izsMg)}>
                <RadialSummary
                  className={classNames(
                    "__wab_instance",
                    sty.radialSummary__rbSM
                  )}
                  nobox={true}
                />
              </div>
              <div className={classNames(projectcss.all, sty.column__xiCdZ)}>
                <RadialSummary
                  className={classNames(
                    "__wab_instance",
                    sty.radialSummary__q6ZjC
                  )}
                  nobox={true}
                />
              </div>
              <div className={classNames(projectcss.all, sty.column__irC1)}>
                <RadialSummary
                  className={classNames(
                    "__wab_instance",
                    sty.radialSummary__ePjZn
                  )}
                  nobox={true}
                />
              </div>
              <div className={classNames(projectcss.all, sty.column___4LBd)}>
                <RadialSummary
                  className={classNames(
                    "__wab_instance",
                    sty.radialSummary___1K910
                  )}
                  nobox={true}
                />
              </div>
              <div className={classNames(projectcss.all, sty.column__kzPF)}>
                <RadialSummary
                  className={classNames(
                    "__wab_instance",
                    sty.radialSummary__qCobv
                  )}
                  nobox={true}
                />
              </div>
            </Stack__>
          </div>
          <div className={classNames(projectcss.all, sty.freeBox__r6KIy)}>
            <Footer
              data-plasmic-name={"footer"}
              data-plasmic-override={overrides.footer}
              className={classNames("__wab_instance", sty.footer)}
            />
          </div>
        </Stack__>
      </div>
    </React.Fragment>
  );
}

const PlasmicDescendants = {
  root: ["root", "navBar2", "h1", "citySummary", "footer"],
  navBar2: ["navBar2"],
  h1: ["h1"],
  citySummary: ["citySummary"],
  footer: ["footer"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicTerminal__ArgProps,
          internalVariantPropNames: PlasmicTerminal__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicTerminal__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicTerminal";
  } else {
    func.displayName = `PlasmicTerminal.${nodeName}`;
  }
  return func;
}

export const PlasmicTerminal = Object.assign(
  // Top-level PlasmicTerminal renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    navBar2: makeNodeComponent("navBar2"),
    h1: makeNodeComponent("h1"),
    citySummary: makeNodeComponent("citySummary"),
    footer: makeNodeComponent("footer"),
    // Metadata about props expected for PlasmicTerminal
    internalVariantProps: PlasmicTerminal__VariantProps,
    internalArgProps: PlasmicTerminal__ArgProps,
    // Page metadata
    pageMetadata: {
      title: "Basil Labs Global Rankings",
      description:
        "A global index of retailers benchmarked by consumer experience",
      ogImageSrc:
        "https://site-assets.plasmic.app/a9c047168a332e71149b68af02fe575a.png",
      canonical: ""
    }
  }
);

export default PlasmicTerminal;
/* prettier-ignore-end */
